export const QUOTES_ACTION = {
    RESET_QUOTES_LIST_STATE: "RESET_QUOTES_LIST_STATE",
    REQUEST_QUOTES_LIST: "REQUEST_QUOTES_LIST",
    RESPONSE_QUOTES_LIST: "RESPONSE_QUOTES_LIST",
    ERROR_QUOTES_LIST: "RESPONSE_QUOTES_LIST",

    RESET_ADD_QUOTE_STATE: "RESET_ADD_QUOTE_STATE",
    REQUEST_ADD_QUOTE: "REQUEST_ADD_QUOTE",
    RESPONSE_ADD_QUOTE: "RESPONSE_ADD_QUOTE",
    ERROR_ADD_QUOTE: "ERROR_ADD_QUOTE",

    RESET_EDIT_QUOTE_STATE: "RESET_EDIT_QUOTE_STATE",
    REQUEST_EDIT_QUOTE: "REQUEST_EDIT_QUOTE",
    RESPONSE_EDIT_QUOTE: "RESPONSE_EDIT_QUOTE",
    ERROR_EDIT_QUOTE: "ERROR_EDIT_QUOTE",

    RESET_QUOTE_BY_ID_STATE :"RESET_QUOTE_BY_ID_STATE",
    REQUEST_QUOTE_BY_ID:"REQUEST_QUOTE_BY_ID",
    RESPONSE_QUOTE_BY_ID:"RESPONSE_QUOTE_BY_ID",
    ERROR_QUOTE_BY_ID:"ERROR_QUOTE_BY_ID",
}

export const setResetEditQuoteState = () => ({
    type: QUOTES_ACTION.RESET_EDIT_QUOTE_STATE,
    data: undefined
});

export const requestEditQuote = (params) => ({
    type: QUOTES_ACTION.REQUEST_EDIT_QUOTE,
    data: params
});

export const responseEditQuote = (res) => ({
    type: QUOTES_ACTION.RESPONSE_EDIT_QUOTE,
    data: res
});

export const errorEditQuote = (err) => ({
    type: QUOTES_ACTION.ERROR_EDIT_QUOTE,
    data: err
});


export const setResetAddQuoteState = () => ({
    type: QUOTES_ACTION.RESET_ADD_QUOTE_STATE,
    data: undefined
});

export const requestAddQuote = (params) => ({
    type: QUOTES_ACTION.REQUEST_ADD_QUOTE,
    data: params
});

export const responseAddQuote = (res) => ({
    type: QUOTES_ACTION.RESPONSE_ADD_QUOTE,
    data: res
});

export const errorAddQuote = (err) => ({
    type: QUOTES_ACTION.ERROR_ADD_QUOTE,
    data: err
});




export const setResetQuotesListState = () => ({
    type: QUOTES_ACTION.RESET_QUOTES_LIST_STATE,
    data: undefined
});

export const requestQuotesList = (params) => ({
    type: QUOTES_ACTION.REQUEST_QUOTES_LIST,
    data: params
});

export const responseQuotesList = (res) => ({
    type: QUOTES_ACTION.RESPONSE_QUOTES_LIST,
    data: res
});

export const errorQuotesList = (err) => ({
    type: QUOTES_ACTION.ERROR_QUOTES_LIST,
    data: err
});

 export const setResetStateQuoteById = () => ({
    type: QUOTES_ACTION.RESET_QUOTE_BY_ID_STATE,
    data: undefined
  });
  
  export const requestQuoteById = (params) =>({
    type:QUOTES_ACTION.REQUEST_QUOTE_BY_ID,
    data: params
  })
  export const responseQuoteById = (res) => ({
    type: QUOTES_ACTION.RESPONSE_QUOTE_BY_ID,
    data: res
  });
  
  export const errorQuoteById = (err) => ({
    type: QUOTES_ACTION.ERROR_QUOTE_BY_ID,
    data: err
  });